module.exports = __webpack_public_path__ + "img/CQ(1).d4248ef2.jpg";